module.exports = __webpack_public_path__ + "fontawesome-webfont.ttf?b06871f281fee6b241d60582ae9369b9";